import { EventDifficultyLevel } from '../../../../../../App.types'
import {
  BRAND_SELECTED_LEVEL_ICON,
  BRAND_SELECTED_LOCATION_ICON,
  LEVEL_ICON,
  LOCATION_ICON,
} from '../../../../../../App.icons'

import { FILTER_TYPE, ActivityLocationType, FILTER_OPTIONS } from './Filters.types'

const LOCATION_OFFERING_FILTER_OPTIONS = Object.values(ActivityLocationType) as Array<ActivityLocationType>

const LEVEL_FILTER_OPTIONS = [
  EventDifficultyLevel.BEGINNER,
  EventDifficultyLevel.INTERMEDIATE,
  EventDifficultyLevel.PROFESSIONAL,
]

// TRANSLATIONS
export const LEVEL_TRANSLATION_MAPPING: Record<
  EventDifficultyLevel,
  'level-all' | 'level-beginner' | 'level-intermediate' | 'level-advanced'
> = {
  [EventDifficultyLevel.ALL]: 'level-all',
  [EventDifficultyLevel.BEGINNER]: 'level-beginner',
  [EventDifficultyLevel.INTERMEDIATE]: 'level-intermediate',
  [EventDifficultyLevel.PROFESSIONAL]: 'level-advanced',
}

// TRANSLATIONS
export const LOCATION_OFFERING_TRANSLATION_MAPPING: Record<
  ActivityLocationType,
  'offering-indoor' | 'offering-outdoor' | 'offering-online'
> = {
  [ActivityLocationType.INDOOR]: 'offering-indoor',
  [ActivityLocationType.OUTDOOR]: 'offering-outdoor',
  [ActivityLocationType.ONLINE]: 'offering-online',
}

// TRANSLATIONS
// Mainly built to help with typing - the i18n needs to know the exact translation id's
export const FILTER_OPTIONS_TRANSLATION_MAPPING: Record<
  ActivityLocationType | EventDifficultyLevel,
  | 'offering-indoor'
  | 'offering-outdoor'
  | 'offering-online'
  | 'level-all'
  | 'level-beginner'
  | 'level-intermediate'
  | 'level-advanced'
> = {
  ...LEVEL_TRANSLATION_MAPPING,
  ...LOCATION_OFFERING_TRANSLATION_MAPPING,
}

export const FILTER_DATA: Record<
  FILTER_TYPE,
  {
    deskTopHeaderTranslationKey: 'offering-filters-header-desktop' | 'level-filters-header-desktop'
    mobileHeaderTranslationKey: 'offering-filters-header-mobile' | 'level-filters-header-mobile'
    options: Array<FILTER_OPTIONS>
    icons: {
      selected: string
      default: string
    }
  }
> = {
  [FILTER_TYPE.LOCATION_OFFERING]: {
    deskTopHeaderTranslationKey: 'offering-filters-header-desktop',
    mobileHeaderTranslationKey: 'offering-filters-header-mobile',
    options: LOCATION_OFFERING_FILTER_OPTIONS,
    icons: {
      selected: BRAND_SELECTED_LOCATION_ICON,
      default: LOCATION_ICON,
    },
  },
  [FILTER_TYPE.LEVEL]: {
    deskTopHeaderTranslationKey: 'level-filters-header-desktop',
    mobileHeaderTranslationKey: 'level-filters-header-mobile',
    options: LEVEL_FILTER_OPTIONS,
    icons: {
      selected: BRAND_SELECTED_LEVEL_ICON,
      default: LEVEL_ICON,
    },
  },
}
